export default {
  type: "photography",
  img: "Norway.jpg",
  id: 'photography_Norway',
  new: false,
  text: {
    title: "Into the vikings' land",
    description: "A collection of photographies taken during multiple trips in Norway."
  }
};
